/**
 * Uploads a single file body to a pre-signed S3 URL using PUT.
 *
 * The pre-signed URL already carries its own signature in the query string —
 * we MUST NOT attach our own Authorization headers (that's why this bypasses
 * RequestAPI / axios interceptors and uses raw fetch).
 *
 * @throws Error when the upload responds with a non-2xx status.
 */
export const uploadToS3 = async (
  uploadUrl: string,
  file: File,
  signal?: AbortSignal,
): Promise<void> => {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': file.type },
    signal,
  });

  if (!response.ok) {
    throw new Error(
      `S3 upload failed: ${response.status} ${response.statusText}`,
    );
  }
};
